<template>
    <div class="closedLoopPie-container">
        <div id="totalPie" class="totalPie">
            <ve-pie
                :key="loadTimer"
                v-if="isShowPie"
                :title="pie.title"
                :toolbox="pie.toolbox"
                :colors="pie.color"
                :tooltip="pie.tooltip"
                :calculable="pie.calculable"
                :legend="pie.legend"
                :series="pie.series"
                @ready="onPieReady($event)"
            />             
        </div>
        <el-dialog
          title="流程详情"
          :fullscreen="true"
          append-to-body
          :visible.sync="isShowProcessInstanceDetail"
          >
            <ProcessDetail 
                v-if="isShowDetail" 
                :instances="instancesInfo"
                :isRead="true"
            /> 
        </el-dialog>
    </div>
</template>

<script>
    // import { pie } from './default-data';
    import { clone } from 'lodash';
    import { getProcessDetailForCloseBI, getProcessInstancesDetail } from '@/data-model';
    import ProcessDetail from '@/pages/process/MyProcess/ProcessDetail';
    
    const instanceId = '';
    const that = this;
    export default {
        components: {
            ProcessDetail
        },
        props: {
            currentProcess: {
                type: Object
            }
        },
        data () {
            var self = this;
            window.detailClickEvent = async function () {
                self.isShowDetail = false;
                self.instancesInfo = await getProcessInstancesDetail(that.instanceId);
                self.isShowDetail = true;
                self.isShowProcessInstanceDetail = true;
            };
            return {
                labelOpen: {
                    normal: {
                        color: '#ff0000',
                        label: {
                            show: true,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        }
                    }
                },
                labelClosed: {
                    normal: {
                        color: '#32cd32',
                        label: {
                            show: true,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        }
                    }
                },
                loadTimer: '',
                isShowPie: false,
                pie: {
                    color: ['#2ec7c9', '#b6a2de', '#5ab1ef', '#6fca00', '#f0e68c'],
                    title: {
                        text: '详细状态'
                        // x: 'center'
                    },
                    legend: {
                        // x : 'center',
                        y: 30,
                        data: []
                    },
                    tooltip: {
                        show: true,
                        trigger: 'item',
                        alwaysShowContent: true
                    },
                    toolbox: {
                        x2: 20,
                        show: true,
                        feature: {
                            saveAsImage: {show: true}
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            center: ['50%', '55%'],
                            radius: ['40%', '55%'],
                            x: '10%', // for funnel
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: true,
                                        formatter: function (params) {
                                            return params.name + (params.data.loopState && params.data.loopState == 1 ? ': 已满足' : ': 未满足');
                                        },
                                        textStyle: {
                                            baseline: 'top',
                                            fontSize: 15,
                                            fontWeight: 'bold'
                                        }
                            
                                    }
                            
                                }
                            },
                            tooltip: {
                                enterable: true, // 鼠标是否可进入提示框浮层中，默认为false，如需详情内交互，如添加链接，按钮，可设置为 true。
                                show: true,
                                // trigger: 'item',
                                formatter: function (params, ticket, callback) {
                                    var processName = params.data.processName;
                                    var loopName = params.data.loopFinalState && params.data.loopFinalState == 1 ? '已闭环' : '未闭环';
                                    var color = params.data.loopFinalState && params.data.loopFinalState == 1 ? 'green' : 'red';
                                    var master = params.data.master;
                                    that.instanceId = params.data.processInstanceId;

                                    let url = window.location.href;
                                    // let goToUrl ='';
                                    // if(url.indexOf("bcbpm.com")!=-1){
                                    //    goToUrl = 'https://www.bcbpm.com/bpm/process/myProcess/'+params.data.processInstanceId;
                                    // } else {
                                    //    goToUrl = url.split('#')[0] + '/#/process/myProcess/'+params.data.processInstanceId;
                                    // }
                                    // var str = '<div style="text-align: center" id="toolTipBox"><p style="font-size:30px;margin:0px;color:' + color + ';"><strong>' + loopName + '</strong></p></br><p style="font-size:15px;margin:0px"><a href="#" style="cursor:hand"><strong>' + processName + '</strong></a></p></br><p style="font-size:10px;margin:0px;">负责人:<strong>' + master + '</strong></p></div>';
                                    var str = '<div style="text-align: center" id="toolTipBox"><p style="font-size:30px;margin:0px;color:' + color + ';"><strong>' + loopName + '</strong></p></br><p style="font-size:15px;margin:0px"><strong>'
                                    + '<span style="pointer-events: all" class="span-line" onclick="detailClickEvent()">' + processName + '</span>'
                                    + '</strong></a></p></br><p style="font-size:10px;margin:0px;">负责人:<strong>' + master + '</strong></p></div>';
                                    return str;
                                },
                                position: function (point, params, dom, rect, size) {
                                    // size参数可以拿到提示框的outerWidth和outerheight，dom参数可以拿到提示框div节点。
                                    // console.log(dom)可以看到，提示框是用position定位
                                    var marginW = Math.ceil(size.contentSize[0] / 2);
                                    var marginH = Math.ceil(size.contentSize[1] / 2);
                                    dom.style.marginLeft = '-' + marginW + 'px';
                                    dom.style.marginTop = '-' + marginH + 'px';
                                    return ['50%', '55%'];
                                },
                                alwaysShowContent: true, // 是否永远显示提示框（默认false,在移出可触发提示框区域后一定时间后隐藏）
                                backgroundColor: 'transparent;', // 设置提示框的背景色
                                textStyle: {
                                    color: '#333'
                                }
                            },
                            data: []
                        }
                    ]
                },
                isShowDetail: false,
                isShowProcessInstanceDetail: false,
                instancesInfo: {}
            };
        },
        created () {
            // this._initPage();
        },
        watch: {
            isShowProcessInstanceDetail (val) {
                // console.log(val);
                if (val) {
                    document.getElementById('toolTipBox').style.cssText ='display:none;';
                } else {
                    document.getElementById('toolTipBox').style.cssText ='display:block;text-align: center';
                }
            }
        },
        methods: {
            async _initPage () {
                this.getProcessDetailForCloseBI();
            },
            async getProcessDetailForCloseBI () {
                this.isShowPie = false;
                this.loadTimer = new Date().getTime();
                let formData = await getProcessDetailForCloseBI(this.currentProcess);
                // console.log(formData);
                let pieData = formData;
                this.pie.series[0].data = pieData;
                if (this.pie.series[0].data) {
                    let pieLegend = [];
                    let pieSeriesData = [];
                    for (var i = 0; i < this.pie.series[0].data.length; i++) {
                        let item = clone(this.pie.series[0].data[i]);
                        pieLegend.push(item.name);
                        if (item.itemStyle === 'labelOpen') {
                            item.itemStyle = this.labelOpen;
                        } else {
                            item.itemStyle = this.labelClosed;
                        }
                        pieSeriesData.push(item);
                    }
                    this.pie.series[0].data = pieSeriesData;
                    this.pie.legend.data = pieLegend;
                    // console.log(this.pie.series[0].data);
                }
                this.isShowPie = true;
            },
            onPieReady ($event) { // 默认显示第一条tootip
                $event._api.dispatchAction({
                    type: 'showTip',
                    seriesIndex: 0,
                    dataIndex: 0
                });
            }
        }
    };
</script>

<style lang="less">
    .closedLoopPie-container {
        flex: 1;
        height: 98%;
        width: 98%;
        .processLine{
            width:100%;
            height:450px;
            float:left;
            overflow-y: auto;    
        }
        .totalPie {
            width:100%;
            height:400px;
            float:left;
        }
        .span-line{
            color:#00F;
        }
        .span-line:hover{
            text-decoration:underline;
            color:#f00;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ClosedLoopPie/ClosedLoopPie.vue